import Announcement from '@/shared/http/repositories/realestate/announcementRepository'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import ActionsForm from '@/shared/mixins/actionsForm'
import { VueEditor } from 'vue2-editor'
import { toast } from '@/shared/utils/UIHelper'

export default {
  mixins: [ActionsForm],
  components: {VueEditor},
  name: 'addAnnouncements',
  data () {
    return {
      principal: true,
      nameInput: '',
      showPdf: true,
      title: 'Adicionar novo comunicado',
      campoEmpreendimento: true,
      btnAvancar: true,
      btnAdicionar: false,
      btnAtualizar: false,
      extensao: '',
      type: false,
      aplicativo: -1,
      empreendimento: [],
      comunicadoInfos: {
        id: '',
        aplicativo: null,
        titulo: '',
        descricao: '',
        destino: null,
        empreendimentoId: null,
        pdf: null
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }]
      ],
      addAnnouncements: null,
      aplicativos: [
        {
          text: 'ZCorretor',
          value: 0
        },
        {
          text: 'Zincorporação Morador',
          value: 1
        }
      ],
      destinos: [
        {
          text: 'Geral',
          value: 0
        },
        {
          text: 'Empreendimentos',
          value: 1
        }
      ]
    }
  },
  props: {
    comunicadoInfo: {
      type: Object,
      default: {}
    }
  },
  mounted () {
    this.comunicadoInfos = this.comunicadoInfo
    EnterpriseRepository.GetAll()
      .then((res) => {
        let stateCompleteData = res.data.data
        stateCompleteData.forEach(stateData => {
          this.empreendimento.push({value: stateData.id, text: stateData.nome})
        })
      })
      .catch(() => {})
  },

  methods: {
    GetValueFile (e) {
      this.nameInput = e.target.files[0].name

      const ultimaBarra = e.target.files[0].type.lastIndexOf('/')
      if (ultimaBarra !== -1) {
        this.extensao = e.target.files[0].type.substring(ultimaBarra + 1)
      }

      if (this.extensao === 'jpeg' || this.extensao === 'png' || this.extensao === 'jpg') {
        this.type = true
      } else {
        this.type = false
      }
      this.comunicadoInfos.pdf = e.target.files[0]
    },
    openFilePdf () {
      document.getElementById('impor-pdf').click()
    },
    selectedDestino () {
      this.$refs.btn_avancar.style.backgroundColor = '#008148'
      this.$refs.btn_avancar.style.color = '#FFFFFF'
      this.$refs.btn_avancar.disabled = false

      let optionDestinoSelected = this.comunicadoInfos.destino

      if (optionDestinoSelected === 1) {
        this.campoEmpreendimento = true
      }

      if (optionDestinoSelected !== 1) {
        this.campoEmpreendimento = false
      }
    },

    avancar () {
      if (this.comunicadoInfos.destino === null && this.comunicadoInfos.empreendimentoId === null) {
        toast.error('Selecione os campos abaixo')
      } else if (this.comunicadoInfos.destino === 1 && this.comunicadoInfos.empreendimentoId === null) {
        toast.error('Selecione um empreendimento')
      } else {
        this.principal = false
        this.btnAvancar = false
        this.btnAdicionar = true
        this.title = 'Importe um arquivo PDF ou adicione um Texto'
        if (this.comunicadoInfos.id) {
          this.btnAdicionar = false
          this.btnAtualizar = true
          this.title = 'Editar comunicado'
        }
      }
    },
    voltar () {
      if (this.principal) {
        this.$root.$emit('bv::hide::modal', 'modalAddAnnouncement')
      }
      this.nameInput = ''
      this.principal = true
      this.btnAvancar = true
      this.btnAdicionar = false
      this.btnAtualizar = false
      this.title = 'Adicionar novo comunicado'
    },
    add () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('titulo', this.comunicadoInfos.titulo)
      data.append('descricao', this.comunicadoInfos.descricao)
      data.append('aplicativo', this.comunicadoInfos.aplicativo)
      data.append('empreendimentoId', this.comunicadoInfos.empreendimentoId)
      data.append('destino', this.comunicadoInfos.destino)
      data.append('arquivo', this.comunicadoInfos.pdf)

      if ((this.comunicadoInfo.titulo && this.comunicadoInfo.descricao) || (this.comunicadoInfo.pdf) != null) {
        Announcement.Create(data, conf)
          .then(response => {
            if (response.status === 200) {
              toast.success(`Comunicado adicionado com sucesso`)
              this.$root.$emit('bv::hide::modal', 'modalAddAnnouncement')
              this.$emit('updateTable')
              this.principal = true
              this.btnAvancar = true
              this.btnAdicionar = false
              this.btnAtualizar = false
            }
          })
          .catch(() => {
            toast.error(`Erro ao adicionar comunicado`)
          })
      } else {
        toast.error(`Erro ao adicionar comunicado, campos vazios`)
      }
    },
    att () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('id', this.comunicadoInfos.id)
      data.append('titulo', this.comunicadoInfos.titulo)
      data.append('descricao', this.comunicadoInfos.descricao)
      data.append('aplicativo', this.comunicadoInfos.aplicativo)
      data.append('empreendimentoId', this.comunicadoInfos.empreendimentoId)
      data.append('destino', this.comunicadoInfos.destino)
      data.append('arquivo', this.comunicadoInfos.pdf)
      data.append('arquivoId', this.comunicadoInfos.arquivoId)
      Announcement.Update(data, conf)
        .then(response => {
          if (response.status === 200) {
            toast.success(`Comunicado atualizado com sucesso`)
            this.$root.$emit('bv::hide::modal', 'modalAddAnnouncement')
            this.$emit('updateTable')
            this.principal = true
            this.btnAvancar = true
            this.btnAdicionar = false
            this.btnAtualizar = false
          }
        })
        .catch(() => {
          toast.error(`Erro ao atualizar o comunicado`)
        })
    },
    onLoad () {
      Announcement.GetSearchEmpreendimento()
        .then(response => {
          this.addAnnouncements = response.data.data
        })
        .catch(() => {})
    },
    addNewAnnouncements () {
      Object.keys(this.comunicadoInfo).forEach(prop => {
        this.comunicadoInfo[prop] = null
      })
      this.showPdf = false
      this.$refs['modalAddAnnouncement'].show()
    },
    EditOpenAddModal (obj) {
      this.showPdf = true
      this.title = 'Editar comunicado'
      this.$refs['modalAddAnnouncement'].show(this.comunicadoInfos = obj)
      this.comunicadoInfos.destino = this.comunicadoInfos.empreendimentoId !== null ? 1 : 0
    },
    onDownloadIncome (id) {
      Announcement.DownloadPDF(id)
        .then(res => {
          if (res.status === 200) {
            let dataResponse = res.data.data
            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataResponse.arquivo}`
            linkDownload.download = `${dataResponse.descricao}.${dataResponse.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
    },
    close () {
      this.principal = true
      this.btnAvancar = true
      this.btnAdicionar = false
      this.btnAtualizar = false
      this.title = 'Adicionar novo comunicado'
      this.$root.$emit('bv::hide::modal', 'modalAddAnnouncement')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/announcements/components/addAnnouncements/addAnnouncements.js